import * as React from "react";
const SvgFiRrSnowmanAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-snowman-alt_svg__a)">
      <path
        fill="#062147"
        d="M23 7h-1V6a1 1 0 0 0-2 0v1.5l-2.275 1.706a5.95 5.95 0 0 0-1.192-2.127A4.94 4.94 0 0 0 17 5c0-2.757-2.243-5-5-5S7 2.243 7 5c0 .744.174 1.444.467 2.079a6 6 0 0 0-1.192 2.127L4 7.5V6a1 1 0 0 0-2 0v1H1a1 1 0 0 0 0 2h1.667l3.359 2.52c.042.483.142.949.292 1.393l-.004.003A6.95 6.95 0 0 0 5 17c0 3.86 3.14 7 7 7s7-3.14 7-7a6.96 6.96 0 0 0-1.314-4.084l-.004-.003q.227-.667.292-1.393L21.333 9H23a1 1 0 0 0 0-2M8 11c0-.821.253-1.602.711-2.264A4.96 4.96 0 0 0 12 10a4.96 4.96 0 0 0 3.289-1.264C15.747 9.399 16 10.18 16 11c0 2.206-1.794 4-4 4s-4-1.794-4-4m4-9c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m5 15c0 2.757-2.243 5-5 5s-5-2.243-5-5c0-.73.165-1.434.465-2.083A5.98 5.98 0 0 0 12 17c1.811 0 3.434-.81 4.535-2.083.299.649.465 1.354.465 2.083"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-snowman-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSnowmanAlt;
